/* eslint-disable -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved. */
import PropTypes from "prop-types";
import { useMediaQuery, useTheme } from "@mui/material";

import { Grid, IconButton } from "@/components/core";

export function Arrow({ className, onClick, icon, sx }: any) {
  const theme = useTheme();
  const mobileMediaQuery = theme.breakpoints.down("md");
  const isMobileDevice = useMediaQuery(mobileMediaQuery);

  return (
    <Grid>
      {!isMobileDevice ? (
        <IconButton
          sx={{
            position: "absolute",
            top: "50%",
            transform: "translateY(-50%)",
            backgroundColor: theme.palette.background.white,
            color: theme.palette.secondary.main,
            zIndex: "tooltip",
            ...sx,
          }}
          onClick={onClick}
        >
          {icon}
        </IconButton>
      ) : null}

      <div
        className={className}
        style={{
          display: "none",
        }}
      />
    </Grid>
  );
}

Arrow.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  icon: PropTypes.element,
  sx: PropTypes.object,
};
